"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminDashboardParticipants = void 0;
const React = __importStar(require("react"));
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const AdminMGTHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/dashboard/AdminMGTHighchartsOptionsProvider");
const antd_1 = require("antd");
const AdminMGTProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/AdminMGTProvider");
const HighchartsComponentWrapper_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsComponentWrapper");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const AdminDashboardParticipants = () => {
    var _a, _b, _c;
    const adminMGTContext = (0, AdminMGTProvider_1.useAdminMGTContext)();
    const inProgress = adminMGTContext.status.inProgress;
    const information = (_a = adminMGTContext.data) === null || _a === void 0 ? void 0 : _a.information;
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Row, { gutter: [32, 16] },
                React.createElement(antd_1.Col, { span: 24, lg: 12 },
                    React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: adminMGTContext.error, data: (_b = information === null || information === void 0 ? void 0 : information.analyticsStoreTotal) === null || _b === void 0 ? void 0 : _b.newParticipants, parameters: LineTypeJSONModel_1.LineType.nonCumulative, highchartsOptionsProviderFn: AdminMGTHighchartsOptionsProvider_1.AdminMGTHighchartsOptionsProvider.getNewUsers },
                        React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsContext.Consumer, null, context => {
                            return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: context.state, inProgress: inProgress });
                        }))),
                React.createElement(antd_1.Col, { span: 24, lg: 12 },
                    React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: adminMGTContext.error, data: (_c = information === null || information === void 0 ? void 0 : information.analyticsStoreTotal) === null || _c === void 0 ? void 0 : _c.newParticipantsCumulative, parameters: LineTypeJSONModel_1.LineType.cumulative, highchartsOptionsProviderFn: AdminMGTHighchartsOptionsProvider_1.AdminMGTHighchartsOptionsProvider.getNewUsers },
                        React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsContext.Consumer, null, context => {
                            return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: context.state, inProgress: inProgress });
                        }))))));
};
exports.AdminDashboardParticipants = AdminDashboardParticipants;
